<script setup lang="ts">
import { useMediaUrl } from "@/composables"
import { calculateStyle } from "../../CmsPage/configuration"
import { getHref, getTarget } from "./link-service"
// props
const props = defineProps<{
    app?: any
    element: any
}>()

const { mediaUrl } = useMediaUrl()
</script>

<template>
    <template v-if="(props.element.overlayHeadline || props.element.overlayText) && props.element.config.buttonLink">
        <a :href="getHref(props.element)" :target="getTarget(props.element)" class="img-overlay">
            <img
                alt=""
                class="img-fluid img-overlay__image"
                :src="mediaUrl(props.element.fileName)"
                :style="calculateStyle(props.element)"
            />
            <div class="img-overlay__overlay">
                <p class="img-overlay__headline">{{ props.element.overlayHeadline }}</p>
                <p class="img-overlay__text">{{ props.element.overlayText }}</p>
            </div>
        </a>
    </template>
    <template v-else-if="props.element.overlayHeadline || props.element.overlayText">
        <div class="img-overlay">
            <img
                alt=""
                class="img-fluid img-overlay__image"
                :src="mediaUrl(props.element.fileName)"
                :style="calculateStyle(props.element)"
            />
            <div class="img-overlay__overlay">
                <p class="img-overlay__headline">{{ props.element.overlayHeadline }}</p>
                <p class="img-overlay__text">{{ props.element.overlayText }}</p>
            </div>
        </div>
    </template>
    <template v-else-if="props.element.config.buttonLink">
        <a :href="getHref(props.element)" :target="getTarget(props.element)">
            <img
                alt=""
                class="img-fluid"
                :src="mediaUrl(props.element.fileName)"
                :style="calculateStyle(props.element)"
            />
        </a>
    </template>
    <template v-else>
        <img
            alt=""
            class="img-fluid"
            :src="mediaUrl(props.element.fileName)"
            :style="calculateStyle(props.element)"
        />
    </template>
</template>
<style lang="scss">
@import "@/styles/variables.scss";
.img-overlay {
    position: relative;
    z-index: 1;
    &__overlay {
        position: absolute;
        z-index: 2;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        text-align: center;
        color: #ffffff;
        vertical-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    &__headline {
        text-transform: uppercase;
        font-style: italic;
        font-weight: bold;
        font-size: 4em;
        margin: -0.25em 0 0 0;
    }
    &__text {
        font-size: 1.5em;
        margin: 0;
    }
    /* &__image { */
    /* } */
}
</style>
